import {Inject, Injectable} from '@angular/core';
import {from, Observable, of, throwError} from 'rxjs';
import {AMDOCS_CONSTANTS} from '../amdocs-constants';
import {catchError, mergeMap} from 'rxjs/operators';
import {CookieService} from 'ngx-cookie';
import {IGatewayConfig, ILoginGatewayConfig} from '../models/configs.model';
import {IApiGatewayClient} from '../models/api.model';

declare var apiGateway: any;
declare var uritemplate: any;

@Injectable({
  providedIn: 'root'
})
export class AmdocsGatewayClientService {

  private loginGatewayConfig: ILoginGatewayConfig;

  constructor(
    @Inject('ILoginGatewayConfig') loginGatewayConfig: ILoginGatewayConfig,
    private cookieService: CookieService
  ) {
    this.loginGatewayConfig = loginGatewayConfig;
  }


  public getLoginApiGatewayClient(useAws4AuthType: boolean = false): IApiGatewayClient {
    return this.getApiGwClient(this.loginGatewayConfig, useAws4AuthType);
  }

  private getApiGwClient(gwConfig: IGatewayConfig, useAws4AuthType = false, withCredentials: boolean = true): IApiGatewayClient {
    const config: any = {
      invokeUrl: gwConfig.url,
      region: gwConfig.region,
      accessKey: '',
      secretKey: '',
      sessionToken: '',
      apiKey: '',
      defaultContentType: 'application/json',
      defaultAcceptType: 'application/json',
      appid: gwConfig.appid
    };

    if (withCredentials) {
      config.accessKey = decodeURIComponent(this.cookieService.get(AMDOCS_CONSTANTS.ACCESS_KEY_ID));
      config.secretKey = decodeURIComponent(this.cookieService.get(AMDOCS_CONSTANTS.SECRET_ACCESS_KEY));
      config.sessionToken = decodeURIComponent(this.cookieService.get(AMDOCS_CONSTANTS.SESSION_TOKEN));
    }

    const apigClient: IApiGatewayClient = {};

    const invokeUrl = config.invokeUrl;
    const part = /(^https?:\/\/[^\/]+)/g.exec(invokeUrl);
    const endpoint = part ? part[1] : '';
    const pathComponent =  invokeUrl.substring(endpoint.length);

    const sigV4ClientConfig = {
      accessKey: config.accessKey,
      secretKey: config.secretKey,
      sessionToken: config.sessionToken,
      serviceName: 'execute-api',
      region: config.region,
      endpoint: endpoint,
      defaultContentType: config.defaultContentType,
      defaultAcceptType: config.defaultAcceptType
    };

    let authType = 'NONE'; // for login gateway
    if (useAws4AuthType && (sigV4ClientConfig.accessKey !== undefined && sigV4ClientConfig.accessKey !== '' && sigV4ClientConfig.secretKey !== undefined && sigV4ClientConfig.secretKey !== '')) {
      authType = 'AWS_IAM'; // For application gateway
    }

    console.log({invokeUrl});

    const simpleHttpClientConfig = {
      endpoint: endpoint,
      defaultContentType: config.defaultContentType,
      defaultAcceptType: config.defaultAcceptType
    };

    const apiGatewayClient = apiGateway.core.apiGatewayClientFactory.newClient(simpleHttpClientConfig, sigV4ClientConfig);


    apigClient.call = (url, method, params: any = {}, body = {}, additionalParams: any = {}) => {
      if (!params) {params = {}; }
      apiGateway.core.utils.assertParametersDefined(params, [], ['body']);
      params.appid = config.appid;
      const reqHeaders = apiGateway.core.utils.parseParametersToObject(params, []);

      if (this.cookieService.get(AMDOCS_CONSTANTS.TOKEN_KEY)) {
        reqHeaders['x-id-token'] = this.cookieService.get(AMDOCS_CONSTANTS.TOKEN_KEY);
      }

      const request = {
        verb: method.toUpperCase(),
        path: pathComponent + uritemplate(url).expand(apiGateway.core.utils.parseParametersToObject(params, Object.keys(params))),
        headers: reqHeaders,
        queryParams: apiGateway.core.utils.parseParametersToObject(params, Object.keys(params)),
        body: body
      };

      return this.handleGatewayResponse(
        from(apiGatewayClient.makeRequest(request, authType, additionalParams, config.apiKey))
      );
    };

    return apigClient;
  }

  public handleGatewayResponse(responseObs: Observable<any>): Observable<any> {
    return responseObs.pipe(
      mergeMap((response: any) => {
        return of(response.data);
      }),
      catchError((err) => {
        let errorMsg = err.toString();
        let code = 0;
        if (err.status !== 200) {
          errorMsg = err.data.message;
          code = err.status;
        }
        console.log('handle-error');
        return this.handleError(errorMsg, code);
      })
    );
  }

  public handleError(errorMessage: string, code: number = 0): Observable<any> {
    const apiError = {code, errorMessage};
    return throwError(apiError);
  }
}
